// extracted by mini-css-extract-plugin
export default {"container":"NewsCard_container__p3o+J","warningContainer":"NewsCard_warningContainer__YLgZS","cardContainer":"NewsCard_cardContainer__eeWVX"};